import { Fragment } from "react";

import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";

/** ========== */

const RequiredDocument = ({
  title,
  data,
  sectionClassName,
  backgroundImage,
}) => {
  const checkBtnRight =
    data.button_image && Object.keys(data.button_image).length > 0;

  const renderButton = () => {
    const { button } = data;

    if (button) {
      if (button.type === "contact-us") {
        return (
          <div className="mt-6 text-center lg:text-left">
            <Link
              href={button.link}
              className={`inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ${
                button.noBackground
                  ? "border border-white font-medium hover:border-bbc-brand-600"
                  : "bg-bbc-primary font-semibold"
              }`}
            >
              {button.text}
            </Link>
          </div>
        );
      }

      if (button.type === "talk-to") {
        return (
          <div className="mt-6">
            <ButtonNew
              as="button"
              onClick={async () => {
                try {
                  // eslint-disable-next-line no-undef
                  await Tawk_API.toggle();
                } catch (error) {
                  console.error();
                }
              }}
            >
              {button.text}
            </ButtonNew>
          </div>
        );
      }

      return (
        <div className="mt-6 text-center lg:text-left">
          <a
            href={button.link}
            className={`inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ${
              button.noBackground
                ? "border border-white font-medium hover:border-bbc-brand-600"
                : "bg-bbc-primary font-semibold"
            }`}
          >
            {button.text}
          </a>
        </div>
      );
    }
  };

  return (
    <div
      className={`relative ${
        sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"
      }`}
    >
      <div className="container relative z-10">
        <div className="row">
          <div className={`${checkBtnRight ? "lg:col-8" : "lg:col-12"}`}>
            <Title
              as="h2"
              text={title}
              className="mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
            />
            {data?.content?.length > 0 &&
              data.content.map((item, index) => {
                return (
                  <Fragment key={index}>
                    {item.title && (
                      <p
                        className="mb-2 text-white "
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    )}
                    {item.listContent && item.listContent.length > 0 && (
                      <ul className="lg:mb-2">
                        {item.listContent.map((element, i) => (
                          <li
                            key={i}
                            className="   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']"
                          >
                            <p
                              dangerouslySetInnerHTML={{ __html: element.text }}
                            ></p>
                            {element.content && (
                              <ul>
                                {element.content.map((element, index) => (
                                  <li
                                    key={index}
                                    className="relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']"
                                  >
                                    {element}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </Fragment>
                );
              })}
            {data?.note && (
              <p
                className="m-0 text-white"
                dangerouslySetInnerHTML={{ __html: data.note }}
              />
            )}
            <div className="text-center lg:text-left">{renderButton()}</div>
          </div>

          {checkBtnRight && (
            <div className="lg:col-4">
              {data.button_image.type && data.button_image.type === "post" ? (
                <a
                  href={data.button_image.uri}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img
                    src={data.button_image.src}
                    alt={data.button_image.alt}
                    width={data.button_image.width || 350}
                    height={data.button_image.height || 350}
                    className="transition-all duration-200 hover:scale-105"
                    wrapper={{
                      className:
                        "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center",
                    }}
                  />
                </a>
              ) : (
                <Link
                  href={data.button_image.uri}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Img
                    src={data.button_image.src}
                    alt={data.button_image.alt}
                    width={350}
                    height={350}
                    className="transition-all duration-200 hover:scale-105"
                    wrapper={{
                      className:
                        "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center",
                    }}
                  />
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
      <Img
        src={backgroundImage}
        width={1920}
        height={737}
        className="h-full w-full"
        wrapper={{ className: "absolute top-0 left-0 w-full h-full z-0" }}
      />
    </div>
  );
};

export default RequiredDocument;

RequiredDocument.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  sectionClassName: PropTypes.string,
  backgroundImage: PropTypes.string,
};

RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: "",
};

/** ========== */
